<template>
  <div class="form-control">
    <v-layout row wrap>
      <v-flex xs12>
        <v-checkbox v-model="filter.lamySendNotiMember" color="primary" class="mt-0">
          <template v-slot:label>
            <div @click.stop="" style="display: flex; width: 100%; cursor: auto">
              <div class="pt-2 pr-2">ส่งหา สมาชิก ที่ใกล้หมดอายุ</div>
              <div>
                <input
                  :disabled="!filter.lamySendNotiMember"
                  name="daySendNoti"
                  v-model="filter.lamyDaySendNoti"
                  style="width: 60px"
                  class="form-control px-0 py-3 text-xs-center"
                  type="number"
                  onKeyPress="if(this.value.length > 2) return false;"
                />
              </div>
              <div class="pt-2 pl-2">วัน</div>
            </div>
          </template>
        </v-checkbox>
      </v-flex>

      <v-flex xs3 class="pa-2">
        <div class="caption">Member Type</div>
        <multiselect
          v-model="filter.lamy_member_type"
          :options="memberTypeOptions"
          label="label"
          :searchable="false"
          selectLabel
          selectedLabel
          deselect-label
          :multiple="true"
          :allow-empty="true"
          :placeholder="$t('Member Type')"
          track-by="label"
        ></multiselect>
      </v-flex>
      <v-flex xs3 class="pa-2">
        <div class="caption">Group</div>
        <multiselect
          v-model="filter.lamy_interested_product_type"
          :options="interstedOptions"
          :searchable="false"
          selectLabel
          selectedLabel
          deselect-label
          :multiple="false"
          :allow-empty="true"
          @input="handleChangeInterestedProductType"
        ></multiselect>
      </v-flex>

      <v-flex xs3 class="pa-2">
        <div class="caption">ยอดการสั่งซื้อสมาชิก</div>
        <div style="display: flex; width: 100%; cursor: auto">
          <div class="pt-2 pr-2">ตั้งแต่</div>
          <div>
            <input
              :disabled="
                !filter.lamy_interested_product_type ||
                (filter.lamy_interested_product_type &&
                  filter.lamy_interested_product_type !== 'มียอดซื้อสินค้าแล้ว')
              "
              v-model="filter.lamy_total_purchase_from"
              style="width: 60px"
              class="form-control pa-0 text-xs-center"
              type="number"
              onKeyPress="if(this.value.length > 9) return false;"
            />
          </div>
          <div class="pt-2 px-2">ถึง</div>
          <div>
            <input
              :disabled="
                !filter.lamy_interested_product_type ||
                (filter.lamy_interested_product_type &&
                  filter.lamy_interested_product_type !== 'มียอดซื้อสินค้าแล้ว')
              "
              v-model="filter.lamy_total_purchase_to"
              style="width: 60px"
              class="form-control pa-0 text-xs-center"
              type="number"
              onKeyPress="if(this.value.length > 9) return false;"
            />
          </div>
        </div>
      </v-flex>
      <v-flex xs3 class="pa-2">
        <div class="caption">จำนวนที่สั่งซื้อ</div>
        <div style="display: flex; width: 100%; cursor: auto">
          <div class="pt-2 pr-2">ตั้งแต่</div>
          <div>
            <input
              :disabled="
                !filter.lamy_interested_product_type ||
                (filter.lamy_interested_product_type &&
                  filter.lamy_interested_product_type !== 'มียอดซื้อสินค้าแล้ว')
              "
              v-model="filter.lamy_total_product_purchase_from"
              style="width: 60px"
              class="form-control pa-0 text-xs-center"
              type="number"
              onKeyPress="if(this.value.length > 9) return false;"
            />
          </div>
          <div class="pt-2 px-2">ถึง</div>
          <div>
            <input
              :disabled="
                !filter.lamy_interested_product_type ||
                (filter.lamy_interested_product_type &&
                  filter.lamy_interested_product_type !== 'มียอดซื้อสินค้าแล้ว')
              "
              v-model="filter.lamy_total_product_purchase_to"
              style="width: 60px"
              class="form-control pa-0 text-xs-center"
              type="number"
              onKeyPress="if(this.value.length > 9) return false;"
            />
          </div>
        </div>
      </v-flex>
      <v-flex xs6 class="pa-2">
        <div class="form-control">
          <div class="caption">Category</div>
          <div>
            <multiselect
              :disabled="!filter.lamy_interested_product_type"
              v-model="filter.lamy_product_category"
              :options="lamyFilterProductOptions.categories"
              :allow-empty="true"
              :searchable="true"
              :openDirection="'bottom'"
              selectLabel
              selectedLabel
              deselect-label
              :multiple="true"
              placeholder="All Categories"
            ></multiselect>
          </div>
        </div>
      </v-flex>
      <v-flex xs6 class="pa-2">
        <div class="form-control">
          <div class="caption">Model</div>
          <div>
            <multiselect
              v-model="filter.lamy_product_model"
              :options="modelOptions"
              :allow-empty="true"
              :searchable="true"
              :openDirection="'bottom'"
              selectLabel
              selectedLabel
              deselect-label
              :multiple="true"
              :disabled="!filter.lamy_product_category || filter.lamy_product_category.length === 0"
              placeholder="All Models"
            ></multiselect>
          </div>
        </div>
      </v-flex>
      <v-flex xs6 class="pa-2">
        <div class="form-control">
          <div class="caption">Product Name</div>
          <div>
            <multiselect
              v-model="filter.lamy_product_name"
              :options="productOptions"
              :allow-empty="true"
              :searchable="true"
              :openDirection="'bottom'"
              selectLabel
              selectedLabel
              deselect-label
              :multiple="true"
              :disabled="!filter.lamy_product_category || filter.lamy_product_category.length === 0"
              placeholder="All Products"
            ></multiselect>
          </div>
        </div>
      </v-flex>
      <v-flex xs6 class="pa-2">
        <div class="form-control">
          <div class="caption">Size</div>
          <div>
            <multiselect
              v-model="filter.lamy_product_size"
              :options="sizeOptions"
              :allow-empty="true"
              :searchable="true"
              :openDirection="'bottom'"
              selectLabel
              selectedLabel
              deselect-label
              :multiple="true"
              :disabled="!filter.lamy_product_category || filter.lamy_product_category.length === 0"
              placeholder="All Sizes"
            ></multiselect>
          </div>
        </div>
      </v-flex>
      <v-flex xs6 class="pa-2">
        <div class="form-control">
          <div class="caption">Headtypes</div>
          <div>
            <multiselect
              v-model="filter.lamy_product_head_type"
              :options="headTypeOptions"
              :allow-empty="true"
              :searchable="true"
              :openDirection="'bottom'"
              selectLabel
              selectedLabel
              deselect-label
              :multiple="true"
              :disabled="!filter.lamy_product_category || filter.lamy_product_category.length === 0"
              placeholder="All Headtypes"
            ></multiselect>
          </div>
        </div>
      </v-flex>
      <v-flex xs6 class="pa-2">
        <div class="form-control">
          <div class="caption">Colour</div>
          <div>
            <multiselect
              v-model="filter.lamy_product_colour"
              :options="colourOptions"
              :allow-empty="true"
              :searchable="true"
              :openDirection="'bottom'"
              selectLabel
              selectedLabel
              deselect-label
              :multiple="true"
              :disabled="!filter.lamy_product_category || filter.lamy_product_category.length === 0"
              placeholder="All Colours"
            ></multiselect>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  props: ['value'],
  components: {
    Multiselect
  },
  data() {
    return {
      filter: this.value,
      lamyFilterProductOptions: {
        categories: [],
        colours: [],
        headtypes: [],
        models: [],
        product_names: [],
        sizes: []
      },
      input: {
        category: '',
        model: '',
        product_name: '',
        size: '',
        head_type: '',
        colour: ''
      },
      memberTypeOptions: [
        {
          label: 'ทุก Member Type',
          value: 'all'
        },
        {
          label: 'new',
          value: 'new'
        },
        {
          label: 'silver',
          value: 'silver'
        },
        {
          label: 'gold',
          value: 'gold'
        }
      ],
      interstedOptions: ['สนใจสินค้า', 'มียอดซื้อสินค้าแล้ว']
    }
  },
  mounted() {
    this.handleInitialLamyFilterProduct()
  },
  computed: {
    lamyFilterProductMasterData() {
      return this.$store.state.lamyFilterProductMasterData
    },
    modelOptions() {
      const modelData = this.lamyFilterProductOptions.models
      let models = []

      if (modelData && modelData.length > 0) {
        const selectedCategory = this.input.category
        if (selectedCategory && selectedCategory.length > 0) {
          models = modelData
            .filter((el) => {
              return [...selectedCategory].includes(el.category)
            })
            .map((item) => item.model)
        } else {
          models = modelData.map((el) => el.model)
        }
      }

      return models
    },
    productOptions() {
      const productData = this.lamyFilterProductOptions.product_names
      let products = []

      if (productData && productData.length > 0) {
        let selectedCategory = this.input.category
        let selectedModel = this.input.model

        if (selectedCategory && selectedCategory.length > 0) {
          let tempProducts = []
          tempProducts = productData.filter((el) => {
            return [...selectedCategory].includes(el.category)
          })

          products = tempProducts.map((item) => item.product_name)

          if (selectedModel && selectedModel.length > 0) {
            products = productData
              .filter((el) => {
                return [...selectedModel].includes(el.model)
              })
              .map((item) => item.product_name)
          }
        } else {
          products = productData.map((el) => el.product_name)
        }
      }

      return products
    },
    sizeOptions() {
      const sizeData = this.lamyFilterProductOptions.sizes
      let sizes = []
      let tempSizeOptions = []

      if (sizeData && sizeData.length > 0) {
        let selectedCategory = this.input.category
        let selectedModel = this.input.model
        let tempFilterSizes = []

        if (selectedCategory && selectedCategory.length > 0) {
          tempFilterSizes = sizeData.filter((el) => {
            return [...selectedCategory].includes(el.category)
          })

          tempSizeOptions = tempFilterSizes

          if (selectedModel && selectedModel.length > 0) {
            tempSizeOptions = tempFilterSizes.filter((el) => {
              return [...selectedModel].includes(el.model)
            })
          }
        } else {
          tempSizeOptions = sizeData
        }

        tempSizeOptions.forEach((item) => {
          if (![...sizes].includes(item.size)) {
            sizes.push(item.size)
          }
        })
      }
      return sizes
    },
    headTypeOptions() {
      const headTypeData = this.lamyFilterProductOptions.headtypes
      let headtypes = []
      let tempHeadTypeOptions = []

      if (headTypeData && headTypeData.length > 0) {
        let selectedCategory = this.input.category
        let selectedModel = this.input.model
        let tempFilterHeadType = []

        if (selectedCategory && selectedCategory.length > 0) {
          tempFilterHeadType = headTypeData.filter((el) => {
            return [...selectedCategory].includes(el.category)
          })

          tempHeadTypeOptions = tempFilterHeadType

          if (selectedModel && selectedModel.length > 0) {
            tempHeadTypeOptions = tempFilterHeadType.filter((el) => {
              return [...selectedModel].includes(el.model)
            })
          }
        } else {
          tempHeadTypeOptions = headTypeData
        }

        tempHeadTypeOptions.forEach((item) => {
          if (![...headtypes].includes(item.headtype)) {
            headtypes.push(item.headtype)
          }
        })
      }
      return headtypes
    },
    colourOptions() {
      const colourData = this.lamyFilterProductOptions.colours
      let colours = []
      let tempColourOptions = []

      if (colourData && colourData.length > 0) {
        let selectedCategory = this.input.category
        let selectedModel = this.input.model
        let tempFilterColour = []

        if (selectedCategory && selectedCategory.length > 0) {
          tempFilterColour = colourData.filter((el) => {
            return [...selectedCategory].includes(el.category)
          })

          tempColourOptions = tempFilterColour

          if (selectedModel && selectedModel.length > 0) {
            tempColourOptions = tempFilterColour.filter((el) => {
              return [...selectedModel].includes(el.model)
            })
          }
        } else {
          tempColourOptions = colourData
        }

        tempColourOptions.forEach((item) => {
          if (![...colours].includes(item.colour)) {
            colours.push(item.colour)
          }
        })
      }
      return colours
    }
  },
  methods: {
    handleInitialLamyFilterProduct() {
      if (this.lamyFilterProductMasterData) {
        this.lamyFilterProductOptions = this.lamyFilterProductMasterData
      }
    },
    handleChangeInterestedProductType() {
      if (
        this.filter.lamy_interested_product_type &&
        this.filter.lamy_interested_product_type !== 'มียอดซื้อสินค้าแล้ว'
      ) {
        this.filter.lamy_total_purchase_from = ''
        this.filter.lamy_total_purchase_to = ''
        this.filter.lamy_total_product_purchase_from = ''
        this.filter.lamy_total_product_purchase_to = ''
      }
    }
  },
  watch: {
    value: function (newVal) {
      this.filter = newVal
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/BroadcastFilterProduct.vue